const workapi = [{
    id:1,
    logo: "https://png.pngtree.com/png-clipart/20190921/original/pngtree-file-download-icon-png-image_4719240.jpg",
    title: "Download App",
    info:"Lorem ipsum dolor sit",
},
{
    id:2,
    logo: "https://cdn-icons-png.flaticon.com/512/2618/2618595.png",
    title: "Complete the Instruction",
    info:"Lorem ipsum dolor sit",
},
{
    id:3,
    logo: "https://static.vecteezy.com/system/resources/previews/000/512/428/original/fund-glyph-black-icon-vector.jpg",
    title: "Receive your Funds",
    info:"Lorem ipsum dolor sit",
}

]

export default workapi